import { ICustomReportTemplateListItem } from '@/Interfaces/ReportBuilder/Template.interface';
import {
  CustomReportTemplateDeleteFunction,
  CustomReportTemplateShareFunction,
} from '@/types/ReportBuilder/GridFunction.types';
import { Button, Stack, buttonClasses } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { memo } from 'react';

interface IProps extends GridRenderCellParams<ICustomReportTemplateListItem> {
  onShareTemplate: CustomReportTemplateShareFunction;
  onDeleteTemplate: CustomReportTemplateDeleteFunction;
}

const pillSx = {
  borderRadius: '32px',
  padding: '4px 12px',
  fontSize: '12px',
  [`& .${buttonClasses.startIcon}`]: {
    marginRight: '4px',
  },
};

const ActionChip = memo(({ row, onShareTemplate, onDeleteTemplate }: IProps) => {
  if (!row?.isOwner) return null;
  return (
    <Stack direction='row' spacing={1}>
      <Button variant='outlined' onClick={() => onShareTemplate(row)} sx={pillSx}>
        Share
      </Button>
      <Button variant='outlined' onClick={() => onDeleteTemplate(row)} sx={pillSx}>
        Delete
      </Button>
    </Stack>
  );
});

export default ActionChip;
